<template>
	<div style="display: flex; flex-direction: column; width: 228px; height: 60px;">
		<div :id="echartId" style="height: 60px; width: 228px;"></div>
	</div>
</template>
  
<script>

export default {
	components: {
	},
	props: {
		echartId: {
			type: String,
			default: null,
		},
		option: {
			type: Object,
			default: null
		}
	},
	watch: {
		option(newVal, oldVal) {
			if (newVal) {
				let option = newVal;
				this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
				this.myChart_Bar.setOption(option, true);
				window.addEventListener('resize', () => {
					this.myChart_Bar.resize();
				});
				this.$forceUpdate()
			}
		}
	},
	data() {
		return {
		};
	},
	created() { },
	mounted() {
		if (this.$props.option) {
			let option = this.$props.option;
			this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
			this.myChart_Bar.setOption(option, true);
			window.addEventListener('resize', () => {
				this.myChart_Bar.resize();
			});
			this.$forceUpdate()
		}
		
	},
	methods: {
	},
};
</script>
<style lang="scss" scoped>

</style>
  